import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import Form from 'scenes/PasswordRecovery/components/Form'
import Confirmation from 'scenes/PasswordRecovery/components/Confirmation'
import BaseComponent from 'utils/BaseComponent'
import { isAuthenticated } from 'utils/auth'

import './style.scss'


export class PasswordRecovery extends BaseComponent {
  componentWillMount() {
    if ( isAuthenticated() )
      this.context.router.history.replace('/')
  }

  componentDidMount() {
    document.title = 'Custodian | Iniciar Sesión'
  }

  render () {
    const Component = this.props.currentStep === 0 ? Form : Confirmation
    return (
      <div id="PasswordRecovery">
        <Component location={this.props.location}/>
      </div>
    )
  }
}

PasswordRecovery.defaultProps = {
  currentStep: 0
}

PasswordRecovery.contextTypes = {
  router: PropTypes.object.isRequired
}

const mapStateToProps = (state) => {
  return {
    currentStep: state.passwordRecovery.get('currentStep')
  }
}

export default connect(mapStateToProps)(PasswordRecovery)



// WEBPACK FOOTER //
// ./src/scenes/PasswordRecovery/index.js